export type MetricCategory = "monitoring" | "energy_flow" | "summary"

export function isCompactFigure(_category: MetricCategory): boolean {
  return true
}
